// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.super-pickem-bracket-team-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #fff;
  border: 1px solid #002129;
  border-radius: 4px;
  width: 200px;
  height: 40px;
  min-height: 40px;
  gap: 5px;
  box-sizing: border-box;
  cursor: pointer;
}

.super-pickem-bracket-team-row-placeholder {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #fff;
  border: 1px solid #002129;
  border-radius: 4px;
  width: 200px;
  height: 40px;
  gap: 5px;
  box-sizing: border-box;
}

.super-pickem-bracket-team-seed {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 30px;
  height: 30px;
  background-color: #002129;
  border-radius: 4px;
}
.super-pickem-bracket-team-seed .seed-number {
  font-size: 20px;
  font-weight: 500;
  color: #CD942E;
}

.super-pickem-bracket-team-logo-placeholder {
  width: 30px;
  height: 30px;
  background-color: transparent;
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.super-pickem-bracket-team-logo-placeholder .team-logo {
  width: 100%;
  height: 100%;
  object-fit: contain;
  border-radius: 4px;
}

.super-pickem-bracket-team-name {
  text-align: center;
  display: flex;
  width: 135px;
  height: 30px;
  justify-content: center;
  align-items: center;
}
.super-pickem-bracket-team-name .team-name {
  font-size: 14px;
  font-weight: 700;
  color: #002129;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.super-pickem-live-bracket-team-name {
  text-align: center;
  display: flex;
  width: 95px;
  height: 30px;
  justify-content: center;
  align-items: center;
  text-align: left;
}
.super-pickem-live-bracket-team-name .team-name {
  font-size: 14px;
  font-weight: 700;
  color: #002129;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.super-pickem-live-bracket-team-score {
  text-align: center;
  display: flex;
  width: 40px;
  height: 38px;
  justify-content: center;
  border-left: 1px solid #002129;
  align-items: center;
}
.super-pickem-live-bracket-team-score .team-score {
  font-size: 14px;
  color: #002129;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.super-pickem-live-bracket-team-name-loser {
  text-align: center;
  display: flex;
  height: 30px;
  justify-content: center;
  align-items: center;
  text-align: left;
}
.super-pickem-live-bracket-team-name-loser .team-name-loser {
  font-size: 14px;
  font-weight: 700;
  color: #002129;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.super-pickem-bracket-game-container {
  width: 230px;
  height: 130px;
  background-color: #D9D9D9;
  border-radius: 4px;
  border: 1px solid #002129;
  display: flex;
  flex-direction: column; /* Arrange children in a column */
  justify-content: space-between; /* Space out the rows evenly */
  align-items: center; /* Center content horizontally */
  padding: 10px; /* Add some padding for spacing */
  box-sizing: border-box; /* Include padding in width/height calculations */
}

.super-pickem-bracket-champ-container {
  width: 219px;
  height: 245px;
  background-color: #D9D9D9;
  border-radius: 4px;
  border: 1px solid #002129;
  display: flex;
  flex-direction: column; /* Arrange children in a column */
  justify-content: space-between; /* Space out the rows evenly */
  align-items: center; /* Center content horizontally */
  padding: 10px; /* Add some padding for spacing */
  margin-top: -120px;
  margin-bottom: 79px;
  box-sizing: border-box; /* Include padding in width/height calculations */
}

.super-pickem-game-info {
  text-align: center;
  color: #002129;
  font-weight: 500 !important;
  font-size: 14px !important;
}`, "",{"version":3,"sources":["webpack://./src/components/Brackets/BracketComponents/SuperPickemBracket.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,sBAAA;EACA,yBAAA;EACA,kBAAA;EACA,YAAA;EACA,YAAA;EACA,gBAAA;EACA,QAAA;EACA,sBAAA;EACA,eAAA;AACJ;;AAEA;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,sBAAA;EACA,yBAAA;EACA,kBAAA;EACA,YAAA;EACA,YAAA;EACA,QAAA;EACA,sBAAA;AACJ;;AAGA;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;AAAJ;AAEI;EACI,eAAA;EACA,gBAAA;EACA,cAAA;AAAR;;AAKA;EACI,WAAA;EACA,YAAA;EACA,6BAAA;EACA,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAFJ;AAII;EACI,WAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;AAFR;;AAOA;EACI,kBAAA;EACA,aAAA;EACA,YAAA;EACA,YAAA;EACA,uBAAA;EACA,mBAAA;AAJJ;AAMI;EACI,eAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAJR;;AASA;EACE,kBAAA;EACA,aAAA;EACA,WAAA;EACA,YAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;AANF;AAQE;EACI,eAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AANN;;AAWA;EACE,kBAAA;EACA,aAAA;EACA,WAAA;EACA,YAAA;EACA,uBAAA;EACA,8BAAA;EACA,mBAAA;AARF;AAUE;EACI,eAAA;EACA,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AARN;;AAaA;EACE,kBAAA;EACA,aAAA;EACA,YAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;AAVF;AAYE;EACI,eAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAVN;;AAgBA;EACI,YAAA;EACA,aAAA;EACA,yBAAA;EACA,kBAAA;EACA,yBAAA;EACA,aAAA;EACA,sBAAA,EAAA,iCAAA;EACA,8BAAA,EAAA,8BAAA;EACA,mBAAA,EAAA,gCAAA;EACA,aAAA,EAAA,iCAAA;EACA,sBAAA,EAAA,iDAAA;AAbJ;;AAgBA;EACE,YAAA;EACA,aAAA;EACA,yBAAA;EACA,kBAAA;EACA,yBAAA;EACA,aAAA;EACA,sBAAA,EAAA,iCAAA;EACA,8BAAA,EAAA,8BAAA;EACA,mBAAA,EAAA,gCAAA;EACA,aAAA,EAAA,iCAAA;EACA,kBAAA;EACA,mBAAA;EACA,sBAAA,EAAA,iDAAA;AAbF;;AAgBA;EACI,kBAAA;EACA,cAAA;EACA,2BAAA;EACA,0BAAA;AAbJ","sourcesContent":[".super-pickem-bracket-team-row {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    background-color: #fff;\n    border: 1px solid #002129;\n    border-radius: 4px;\n    width: 200px;\n    height: 40px;\n    min-height: 40px;\n    gap: 5px; // Space between items\n    box-sizing: border-box; // Ensure padding is included in total width\n    cursor: pointer;\n}\n\n.super-pickem-bracket-team-row-placeholder {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    background-color: #fff;\n    border: 1px solid #002129;\n    border-radius: 4px;\n    width: 200px;\n    height: 40px;\n    gap: 5px; // Space between items\n    box-sizing: border-box; // Ensure padding is included in total width\n}\n\n// First Part: Seed Box\n.super-pickem-bracket-team-seed {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 30px; // Fixed width\n    height: 30px; // Fixed height\n    background-color: #002129;\n    border-radius: 4px;\n    \n    .seed-number {\n        font-size: 20px;\n        font-weight: 500;\n        color: #CD942E;\n    }\n}\n\n// Second Part: Logo Placeholder\n.super-pickem-bracket-team-logo-placeholder {\n    width: 30px; // Fixed width\n    height: 30px; // Fixed height\n    background-color: transparent; // Placeholder background color\n    border-radius: 4px;\n    display: flex; // Center the logo\n    justify-content: center;\n    align-items: center;\n\n    .team-logo {\n        width: 100%; // Make the image take up full width of the container\n        height: 100%; // Make the image take up full height of the container\n        object-fit: contain; // Ensure the image scales proportionally within the box\n        border-radius: 4px; // Optional: Matches the placeholder border radius\n    }\n}\n\n// Third Part: Team Name\n.super-pickem-bracket-team-name {\n    text-align: center; // Center text within space\n    display: flex;\n    width: 135px;\n    height: 30px;\n    justify-content: center;\n    align-items: center;\n\n    .team-name {\n        font-size: 14px;\n        font-weight: 700;\n        color: #002129;\n        white-space: nowrap; // Prevent wrapping\n        overflow: hidden; // Hide overflow\n        text-overflow: ellipsis; // Add ellipsis for long text\n        \n    }\n}\n\n.super-pickem-live-bracket-team-name {\n  text-align: center; // Center text within space\n  display: flex;\n  width: 95px;\n  height: 30px;\n  justify-content: center;\n  align-items: center;\n  text-align: left;\n\n  .team-name {\n      font-size: 14px;\n      font-weight: 700;\n      color: #002129;\n      white-space: nowrap; // Prevent wrapping\n      overflow: hidden; // Hide overflow\n      text-overflow: ellipsis; // Add ellipsis for long text\n      \n  }\n}\n\n.super-pickem-live-bracket-team-score {\n  text-align: center; // Center text within space\n  display: flex;\n  width: 40px;\n  height: 38px;\n  justify-content: center;\n  border-left: 1px solid #002129;\n  align-items: center;\n\n  .team-score {\n      font-size: 14px;\n      color: #002129;\n      white-space: nowrap; // Prevent wrapping\n      overflow: hidden; // Hide overflow\n      text-overflow: ellipsis; // Add ellipsis for long text\n      \n  }\n}\n\n.super-pickem-live-bracket-team-name-loser {\n  text-align: center; // Center text within space\n  display: flex;\n  height: 30px;\n  justify-content: center;\n  align-items: center;\n  text-align: left;\n\n  .team-name-loser {\n      font-size: 14px;\n      font-weight: 700;\n      color: #002129;\n      white-space: nowrap; // Prevent wrapping\n      overflow: hidden; // Hide overflow\n      text-overflow: ellipsis; // Add ellipsis for long text\n      \n  }\n}\n\n\n.super-pickem-bracket-game-container {\n    width: 230px;\n    height: 130px;\n    background-color: #D9D9D9;\n    border-radius: 4px;\n    border: 1px solid #002129;\n    display: flex;\n    flex-direction: column; /* Arrange children in a column */\n    justify-content: space-between; /* Space out the rows evenly */\n    align-items: center; /* Center content horizontally */\n    padding: 10px; /* Add some padding for spacing */\n    box-sizing: border-box; /* Include padding in width/height calculations */\n}\n\n.super-pickem-bracket-champ-container {\n  width: 219px;\n  height: 245px;\n  background-color: #D9D9D9;\n  border-radius: 4px;\n  border: 1px solid #002129;  \n  display: flex;\n  flex-direction: column; /* Arrange children in a column */\n  justify-content: space-between; /* Space out the rows evenly */\n  align-items: center; /* Center content horizontally */\n  padding: 10px; /* Add some padding for spacing */\n  margin-top: -120px;\n  margin-bottom: 79px;\n  box-sizing: border-box; /* Include padding in width/height calculations */\n}\n\n.super-pickem-game-info {\n    text-align: center;\n    color: #002129;\n    font-weight: 500 !important; \n    font-size: 14px !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
